import { get } from 'lodash-es';
import { a as BxfOverlayController } from './overlay-controller-8ff05c99.js';
import { B as BxfPositionConstants } from './focus-trap-023cd6d1.js';
import { R as Role } from './role.enum-c3c8cd89.js';

const { DROPDOWN_CONTAINER } = BxfPositionConstants.STRING;
class BxfOverlayDropdownController extends BxfOverlayController {
    host;
    parentElement;
    targetElement;
    sourceElement;
    updateStateCallback;
    options;
    isOutsideOverlayCallback;
    constructor(host, parentElement, targetElement, sourceElement, updateStateCallback, options = {}, isOutsideOverlayCallback) {
        super(host, parentElement, targetElement, sourceElement, updateStateCallback, options, isOutsideOverlayCallback);
        this.host = host;
        this.parentElement = parentElement;
        this.targetElement = targetElement;
        this.sourceElement = sourceElement;
        this.updateStateCallback = updateStateCallback;
        this.options = options;
        this.isOutsideOverlayCallback = isOutsideOverlayCallback;
    }
    appendToContainer(element) {
        super.createOverlayContainer();
        super.appendToContainer(element, DROPDOWN_CONTAINER);
    }
    /**
     * Set aria-expanded to given value for a given target
     * @param {HTMLElement} dropdownTarget
     * @param {string} val
     */
    toggleExpandedForTarget(dropdownTarget, val) {
        if (dropdownTarget) {
            dropdownTarget.setAttribute('aria-expanded', val);
        }
    }
    /**
     * Open overlay and set aria-expanded to true on target
     */
    openOverlayWithPosition() {
        super.openOverlayWithPosition();
        if (get(this.options, 'shouldToggleExpanded', true)) {
            this.toggleExpandedForTarget(this.targetElement, 'true');
        }
    }
    /**
     * Close overlay, set aria-expanded to false on target, and focus target
     * @param isMouseFocus
     */
    close(isMouseFocus = false) {
        super.close(isMouseFocus);
        if (get(this.options, 'shouldToggleExpanded', true)) {
            this.toggleExpandedForTarget(this.targetElement, 'false');
        }
        if (!isMouseFocus) {
            const preventScroll = this.options?.targetElementOptions &&
                'preventScroll' in this.options.targetElementOptions
                ? this.options.targetElementOptions.preventScroll
                : false;
            this.targetElement?.focus({
                preventScroll,
            });
        }
    }
    /**
     * Focus listbox on dropdown open. Overrides default in BxfOverlayController.
     */
    getItemToFocus() {
        return this.sourceElement.querySelector(`[role="${Role.LISTBOX}"]`);
    }
}

export { BxfOverlayDropdownController as B };
